var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRestExpFilled = function SvgRestExpFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "#827127",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.584 1.485A1 1 0 0 0 10.68 0C4.753.17 0 5.028 0 10.996c0 6.075 4.925 11 11 11a11 11 0 0 0 9.902-6.204 1 1 0 0 0-.982-1.434q-.357.03-.724.03A8.696 8.696 0 0 1 10.5 5.692c0-1.528.393-2.962 1.084-4.207"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.75 4.496a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m5.25 1.5a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
export default SvgRestExpFilled;